import { IAppConfig, IAppConfigRaw } from '~/shared/types/configTypes'

export const getAppConfigFromConfigRaw = (
  config: IAppConfigRaw,
): IAppConfig => ({
  amplitudeApiKey: config.amplitude_api_key,
  giaApiKeys: config.gia_api_keys,
  firebaseConfig: config.firebase_config ?? null,
})
